export default "__VITE_ASSET__BNy71OWz__"